
import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const loginUser = (data, callback) => {
    return fetchDataAndProceed('/users/login', METHOD_TYPES.POST, data, callback);
};

export const forgotPassword = (data, callback) => {
    return fetchDataAndProceed('/users/password/forgot', METHOD_TYPES.POST, data, callback);
};

export const verifyToken = (data, callback) => {
    return fetchDataAndProceed('/users/token/verify', METHOD_TYPES.POST, data, callback);
};

export const resetPassword = (data, callback) => {
    return fetchDataAndProceed('/users/password/reset', METHOD_TYPES.POST, data, callback);
};

export const activateUser = (data, callback) => {
    return fetchDataAndProceed('/users/account/verify', METHOD_TYPES.POST, data, callback);
};

export const resendActivationLink = (data, callback) => {
    return fetchDataAndProceed('/users/email/activation', METHOD_TYPES.POST, data, callback);
};

export const updateUserProfile = (data, callback) => {
    return fetchDataAndProceed('/users/admins/profile', METHOD_TYPES.PATCH, data, callback);
};

export const logOutUser = (data, callback) => {
    return fetchDataAndProceed('/users/logout', METHOD_TYPES.POST, data, callback);
};

export const updateBifurcation = (data, callback) => {
    return fetchDataAndProceed('/users/updateUserFilterSelection', METHOD_TYPES.POST, data, callback)
};



// WEBPACK FOOTER //
// ./src/data/redux/admin_details/api.js